import { Spin } from "antd";
import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import ErrorBoundary from "./components/error/errorBoundary ";
import AppLayout from "./components/layout/layout";
import RedirectIfUserAlreadyLogged from "./components/route/redirectIfUserAlreadyLogged";
import RequiredAuth from "./components/route/requiredAuth";
import SegurosContextLayout from "./components/route/segurosContextLayout";
import ForgotPasswordContextProvider from "./context/forgotPasswordContext";
import Login from "./pages/login/login";

import ForgotPasswordPage from "./pages/forgotPassword/forgotPassword";

const LazySegurosPage = lazy(() => import("./pages/seguros/seguros"));
const LazySeguroPage = lazy(() => import("./pages/seguro/seguro"));
const LazySeguroRiesgoPage = lazy(() => import("./pages/seguro/riesgo/riesgo"));

const Fallback = () => {
    return (
        <Spin tip='Cargando...'>
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "100vh",
                }}
            ></div>
        </Spin>
    );
};

function App() {
    return (
        <Suspense fallback={<Fallback />}>
            <Routes>
                {/* Rutas publicas */}
                <Route element={<RedirectIfUserAlreadyLogged />}>
                    <Route path='/login' element={<Login />} />
                    <Route
                        path='/forgotpassword'
                        element={
                            <ForgotPasswordContextProvider>
                                <ForgotPasswordPage />
                            </ForgotPasswordContextProvider>
                        }
                    />
                </Route>

                <Route element={<RequiredAuth />}>
                    <Route element={<SegurosContextLayout />}>
                        <Route path='/' element={<AppLayout />}>
                            <Route
                                exact
                                path='/'
                                element={<LazySegurosPage />}
                            />

                            <Route element={<ErrorBoundary />}>
                                <Route
                                    path='/seguros/:seguroId'
                                    element={<LazySeguroPage />}
                                />
                                <Route
                                    path='/seguros/:seguroId/:endosoId'
                                    element={<LazySeguroPage />}
                                />
                                <Route
                                    path='/seguros/:seguroId/riesgo/:riesgoId'
                                    element={<LazySeguroRiesgoPage />}
                                />
                            </Route>
                        </Route>
                    </Route>
                </Route>
            </Routes>
        </Suspense>
    );
}

export default App;
